/* Luméole — interactions for the bespoke product page (Dawn-compatible).
   Only touches Luméole markup; Dawn's own header/cart JS is untouched. */
(function () {
  /* ---------- Date de livraison estimée (2–4 jours ouvrés) ---------- */
  function plusJoursOuvres(date, n) {
    var d = new Date(date);
    var ajoutes = 0;
    while (ajoutes < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) ajoutes++;
    }
    return d;
  }
  function fmtFr(d) {
    return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  document.querySelectorAll('.date-est').forEach(function (el) {
    var d1 = plusJoursOuvres(new Date(), 2);
    var d2 = plusJoursOuvres(new Date(), 4);
    el.textContent = 'Livraison estimée entre le ' + fmtFr(d1) + ' et le ' + fmtFr(d2);
  });

  var buybox = document.querySelector('.buybox');
  if (!buybox) return;

  /* ---------- Galerie : miniatures ---------- */
  var principale = document.querySelector('.galerie-principale img');
  document.querySelectorAll('.galerie-thumbs button').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.galerie-thumbs button').forEach(function (x) { x.classList.remove('actif'); });
      t.classList.add('actif');
      var img = t.querySelector('img');
      if (principale && img) { principale.src = img.src; principale.alt = img.alt; }
    });
  });

  /* ---------- Cartes d'offre = sélecteur de variante natif ---------- */
  var idInput = document.querySelector('#lumeole-variant-id');
  function setActiveOffer(btn) {
    document.querySelectorAll('.offre[data-variant-id]').forEach(function (x) { x.classList.remove('actif'); });
    btn.classList.add('actif');
    var price = btn.getAttribute('data-price');
    var label = btn.getAttribute('data-label') || ('Ajouter au panier — ' + price);
    if (idInput) idInput.value = btn.getAttribute('data-variant-id');
    document.querySelectorAll('.prix').forEach(function (p) { p.textContent = price; });
    var ctaSpan = document.querySelector('#cta-principal span');
    if (ctaSpan) ctaSpan.textContent = label;
    var sPrix = document.querySelector('.sticky-atc .s-prix');
    if (sPrix) sPrix.textContent = price;
  }
  document.querySelectorAll('.offre[data-variant-id]').forEach(function (b) {
    if (b.getAttribute('data-unavailable') === 'true') return;
    b.addEventListener('click', function () { setActiveOffer(b); });
  });

  /* ---------- Barre sticky mobile ---------- */
  var cta = document.querySelector('#cta-principal');
  var sticky = document.querySelector('.sticky-atc');
  if (cta && sticky) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (window.innerWidth <= 960) {
          sticky.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        } else {
          sticky.classList.remove('visible');
        }
      });
    });
    obs.observe(cta);
    var sBtn = document.querySelector('#sticky-atc-btn');
    if (sBtn) sBtn.addEventListener('click', function () { cta.click(); });
  }
})();
